import React from "react";
import styled from "styled-components";

import imagemFundo from "../../images/imagemfundo.png";
import alerta from "../../images/alerta.png";
import Globais from "../../css/Globais";

const Container = styled.section`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background-color: #fff;
  opacity: 80%;
`;
const Imagem = styled.img`
  background-repeat: no-repeat;
  background-position: center;
  width: 100%;
`;
const ImagemEmail = styled.img`
  background-repeat: no-repeat;
  background-position: center;
  width: 7rem;
  height: 7rem;
  justify-self: center;
`;
const ContainerEmail = styled.div`
  width: 100%;
  height: 60%;
  max-width: 30rem;
  min-width: 15rem;
  min-height: 30rem;
  max-height: 40rem;
  justify-self: flex-start;

  box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px,
    rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px,
    rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;
  background-color: #fff;
  border-radius: 30px;
  position: absolute;
  z-index: 0;
  display: grid;
  grid-template: 20% 20% 60%/ 100%;
  justify-content: center;
  aligm-itens: center;
`;

const TextWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-left: 2rem;
  margin-right: 2rem;
  margin-top: 2rem;
  a {
    color: #2d3436;
  }
  a:hover {
    color: #636e72;
  }
  @media (min-width: 450px) {
    margin-left: 5rem;
    margin-right: 5rem;
  }
`;

const ContainerTitulo = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
`;

const Titulo = styled.h2`
  width: 10rem;
  text-align: center;
  align-self: center;
  color: ${Globais.CorAzulBackGround};
  font-size: 1.8rem;
  width: 80%;
  @media (max-width: 300px) {
    font-size: 1.2rem;
  }
`;

const H3 = styled.h3`
  text-align: center;

  color: ${Globais.CorAzulBackGround};
  font-size: 1rem;
  @media (max-width: 300px) {
    font-size: 0.9rem;
  }
`;

export default function ViewAtivacaoExpirada() {
  return (
    <Container>
      <Imagem src={imagemFundo} alt="" />
      <ContainerEmail>
        <ContainerTitulo>
          <Titulo>
            E-mail de ativação de cadastro está inválido <br />
          </Titulo>
        </ContainerTitulo>
        <ImagemEmail src={alerta} alt="" />

        <TextWrapper>
          <H3>
            Esse e-mail tem validade de 7 dias e é possível que esse tempo já
            tenha expirado. <br />
            <br />
            Uma outra possibilidade é que você já tenha ativado seu cadastro.
            <br />
            <br />
            Tente efetuar <a href="/login">login </a>e caso não consiga clique
            em esqueci a senha e siga o passo a passo.
            <br />
            <br />
            Qualquer dúvida entre em <a href="/contato">contato</a> conosco.
          </H3>
        </TextWrapper>
      </ContainerEmail>
    </Container>
  );
}
